import type { SearchMatches } from 'widgets/sports-menu-widget/model/types';

import { ResultGroup } from '../ResultGroup';

import { TXTWCL_Runner } from './RunnersResultGroup.messages.json';

interface Props {
  runners: SearchMatches['runners'];
}
export const RunnersResultGroup = ({ runners }: Props) => (
  <ResultGroup resultsGroup={runners} titleTranslationTag={TXTWCL_Runner} />
);
